/* loaded by smart-asset */
export default require("./search-24px~nCBPilBp.svg")